/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calm_Fine_Robin_RadiateInputs */

const fr_calm_fine_robin_radiate = /** @type {(inputs: Calm_Fine_Robin_RadiateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vidéo`)
};

/**

* @param {Calm_Fine_Robin_RadiateInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const calm_fine_robin_radiate = /** @type {((inputs?: Calm_Fine_Robin_RadiateInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calm_Fine_Robin_RadiateInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_calm_fine_robin_radiate(inputs)
});